import { render, staticRenderFns } from "./QAReport.vue?vue&type=template&id=05d7bd20&scoped=true&"
import script from "./QAReport.vue?vue&type=script&lang=js&"
export * from "./QAReport.vue?vue&type=script&lang=js&"
import style0 from "./QAReport.vue?vue&type=style&index=0&id=05d7bd20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7bd20",
  null
  
)

export default component.exports